module.exports = __webpack_public_path__ + "static/media/GearSettings.b92b00f3.svg";